import {DateTime} from "luxon";
import { GeneralCatalogItemInterface } from "./interfaces/GeneralCatalogItemInterface";
import { SchemaSettings } from "./objects/SchemaSettings";
import { Element }from "@api/models/Element";

export class GeneralCatalogItem extends Element implements GeneralCatalogItemInterface {
    static readonly LocalizableField: Array<keyof GeneralCatalogItem> = ['title', 'description', 'webClientDescription'];
    static readonly FillableFields: Array<keyof GeneralCatalogItem> = [
        'bannerFileId',
        'description',
        'fileIds',
        'iconFileId',
        'id',
        'isOnline',
        'links',
        'needContactsAgreement',
        'onlineParams',
        'orderIndex',
        'ownerIds',
        'parentId',
        'tagsIds',
        'title',
        'userProfileIds',
        'webClientDescription'
    ]

    parentId: string;
    title: string;
    imageFileId?: string;
    iconFileId?: string;
    bannerFileId?: string;
    orderIndex: number;
    description: string;
    webClientDescription: string;
    userProfileIds?: string[];
    addition?: string;
    isOnline?: boolean;
    tagsIds?: string[];
    fileIds?: string[];
    links?: Record<string, string>;
    [key: string]: boolean | string | number | string[] | undefined | DateTime | Record<string, any>;

    constructor(data: GeneralCatalogItem, schema = '') {
        super(data, schema, ['beginAt', 'endAt']);

        Object.assign(this, data);
        if (typeof data.links === 'object' && data.links !== null && !Array.isArray(data.links)) {
            this.links = Object.assign({}, data.links);
        }
    }

    static getSchemaSettings(schemaId = '') {
        if (!schemaId) {
            schemaId = process.env.VUE_APP_EXHIBITION_SCHEMA! || 'Exhibition';
        }
        return new SchemaSettings<GeneralCatalogItem>(schemaId, GeneralCatalogItem.LocalizableField, GeneralCatalogItem.FillableFields);
    }
}
